import script from "./ArchivedMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivedMobile.vue?vue&type=script&setup=true&lang=js"

import "./ArchivedMobile.vue?vue&type=style&index=0&id=7c279685&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c279685"]])

export default __exports__